import {
  createInitialSearchPanelState,
  normalizeSearchPanelState,
  type SearchPanelState,
} from "@tsmono/inspect-components/transcript-search";

import { StoreState } from "./store";

export interface SearchSlice {
  search: {
    panelStates: Record<string, SearchPanelState | undefined>;
  };
  searchActions: {
    setSearchPanelState: (
      key: string,
      updater: SearchPanelState | ((prev: SearchPanelState) => SearchPanelState)
    ) => void;
    clearSearchPanelState: (key: string) => void;
  };
}

export const createSearchSlice = (
  set: (fn: (state: StoreState) => void) => void
): SearchSlice => {
  const slice: SearchSlice = {
    search: {
      panelStates: {},
    },
    searchActions: {
      setSearchPanelState: (key, updater) => {
        set((state) => {
          const prev = normalizeSearchPanelState(
            state.search.panelStates[key] ?? createInitialSearchPanelState()
          );
          state.search.panelStates[key] =
            typeof updater === "function" ? updater(prev) : updater;
        });
      },
      clearSearchPanelState: (key) => {
        set((state) => {
          const { [key]: _removed, ...remaining } = state.search.panelStates;
          state.search.panelStates = remaining;
        });
      },
    },
  };

  return slice;
};
